import { PayloadAction, createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { removeToken } from '../../../utils/authStatus';
import Public from '../../../API/Public';

interface IContactPhones {
  comment: string | null;
  data: [
    {
      name: string | null;
      phone: {
        E164: string | null;
        national: string | null;
        international: string | null;
        frame: string | null;
        valid: boolean;
      };
    },
  ];
}

interface IContactEMail {
  data: string | null;
  comment: string | null;
}

export interface DataState {
  isLogin: boolean | null;
  isPaswordVerified: boolean;
  bonus: number;
  contactPhones: IContactPhones | null;
  contactEMail: IContactEMail | null;
  contacntHelperPhones: IContactPhones | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  favorites: Array<number> | null;
}

const initialState: DataState = {
  isLogin: null,
  isPaswordVerified: false,
  bonus: 0,
  status: 'idle',
  contactPhones: null,
  contactEMail: null,
  contacntHelperPhones: null,
  favorites: null,
};

export const checkAuthStatus = createAsyncThunk('auth/checkAuthStatus', async () => {
  try {
    const data = await Public.getProfile();
    return data;
  } catch (error) {
    console.error('Ошибка при проверке статуса:', error);
    throw error;
  }
});

export const autorizationStatusSlice = createSlice({
  name: 'autorizationStatus',
  initialState,
  reducers: {
    logout: (state) => {
      state.isLogin = false;
      state.bonus = 0;
      state.isPaswordVerified = false;
      removeToken();
    },
    setLogin: (state) => {
      state.isLogin = true;
    },
    setVerified: (state) => {
      state.isPaswordVerified = true;
    },
    setNotVerified: (state) => {
      state.isPaswordVerified = false;
    },
    setBonus: (state, action: PayloadAction<number>) => {
      state.bonus = action.payload;
    },
    setContactPhones: (state, action: PayloadAction<IContactPhones | null>) => {
      state.contactPhones = action.payload;
    },
    setContactEMail: (state, action: PayloadAction<IContactEMail | null>) => {
      state.contactEMail = action.payload;
    },
    setContacntHelperPhones: (state, action: PayloadAction<IContactPhones | null>) => {
      state.contacntHelperPhones = action.payload;
    },
    setFavorites: (state, action: PayloadAction<Array<number>>) => {
      state.favorites = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(checkAuthStatus.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(checkAuthStatus.fulfilled, (state, action) => {
        const items = action.payload;
        if (items.uid) {
          state.isLogin = true;
        } else {
          state.isLogin = false;
        }
        if (items.passport?.approved === true) {
          state.isPaswordVerified = true;
        } else {
          state.isPaswordVerified = false;
        }
        if (items.bonus) {
          state.bonus = items.bonus;
        }
        if (items.info?.email) {
          state.contactEMail = items.info.email;
        }
        if (items.info?.phones_help) {
          state.contacntHelperPhones = items.info.phones_help;
        }
        if (items.info?.phones) {
          state.contactPhones = items.info.phones;
        }
        if (items.favorites) {
          localStorage.removeItem('favourites');
          localStorage.setItem('favourites', items.favorites);
          state.favorites = JSON.parse(items.favorites);
        }
        state.status = 'succeeded';
      })
      .addCase(checkAuthStatus.rejected, (state) => {
        state.isLogin = false;
        state.status = 'failed';
      });
  },
});

export const {
  logout,
  setLogin,
  setVerified,
  setNotVerified,
  setBonus,
  setContactPhones,
  setContactEMail,
  setContacntHelperPhones,
  setFavorites,
} = autorizationStatusSlice.actions;

export default autorizationStatusSlice.reducer;
